"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./ModalOverlay.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModalOverlay = function ModalOverlay(props) {
  var _props$closeModal = props.closeModal,
      closeModal = _props$closeModal === void 0 ? function () {} : _props$closeModal,
      modalVisible = props.modalVisible,
      notOverlayCloseable = props.notOverlayCloseable,
      customClass = props.customClass,
      children = props.children;

  var handleOverlayClick = function handleOverlayClick() {
    if (!notOverlayCloseable) {
      closeModal();
    }
  };

  var modalClasses = (0, _classnames.default)(_defineProperty({
    'modal-2020': true,
    'modal-2020-visible': modalVisible
  }, customClass, customClass));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: modalClasses
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-2020-overlay",
    onClick: handleOverlayClick
  }));
};

var _default = ModalOverlay;
exports.default = _default;